export const TemplatePool = {
    "email-on-start-payment": {
        name: {
            tag: "imie-nazwisko",
        },
        email: {
            tag: "email",
        },
        phone: {
            tag: "telefon",
        },
        totalPrice: {
            tag: "kwota",
        },
        orderSummary: {
            tag: "link-do-podsumowania",
        },
        linkToBasket: {
            tag: "link-do-koszyka",
        },
        buttonToBasket: {
            tag: "przycisk-do-koszyka",
        },
        buttonToSummary: {
            tag: "przycisk-do-podsumowania",
        },
    },
    "content-in-gallery": {
        isLoggedIn: {
            tag: "czy-jest-zalogowany",
        },
    },
    "order-labels-printer": {
        name: {
            tag: "imie-nazwisko",
        },
        email: {
            tag: "email",
        },
        phone: {
            tag: "telefon",
        },
        totalPrice: {
            tag: "kwota",
        },
        group: {
            tag: "nazwa-grupy",
        },
        id: {
            tag: "id",
        },
        orderedFileNames: {
            tag: "nazwy-zamówionych-zdjęć",
        },
        orderedItemsList: {
            tag: "lista-zamówionych-zdjęć",
        },
    },
};
export const TemplatePoolByTag = {};
for (const poolName in TemplatePool) {
    TemplatePoolByTag[poolName] = {};
    const pool = TemplatePool[poolName];
    for (const fieldName in pool) {
        const tag = pool[fieldName].tag;
        TemplatePoolByTag[poolName][tag] = {
            name: fieldName,
        };
    }
}
